import { hasAdvertisingConsent, isOpenAIAdsProduction } from "./openai-ads"

const ANALYTICS_COOKIE = "seam_google_analytics_consent"
const MAX_AGE_SECONDS = 6 * 30 * 24 * 60 * 60

export const hasGoogleAnalyticsConsent = () => {
  if (!isOpenAIAdsProduction()) return false
  if (hasAdvertisingConsent()) return true
  const value = document.cookie
    .split("; ")
    .find((part) => part.startsWith(`${ANALYTICS_COOKIE}=`))
    ?.slice(ANALYTICS_COOKIE.length + 1)
  const decidedAt = Number(value)
  const age = Date.now() - decidedAt
  return decidedAt > 0 && age >= 0 && age <= MAX_AGE_SECONDS * 1000
}

// Bridge the existing marketing analytics choice; keep its original expiry.
export const setGoogleAnalyticsConsent = (
  enabled: boolean,
  decidedAt?: number
) => {
  if (!isOpenAIAdsProduction()) return
  const age = decidedAt == null ? Infinity : Date.now() - decidedAt
  const allowed =
    enabled &&
    decidedAt != null &&
    decidedAt > 0 &&
    age >= 0 &&
    age <= MAX_AGE_SECONDS * 1000
  const remaining = allowed
    ? Math.max(0, Math.ceil(MAX_AGE_SECONDS - age / 1000))
    : 0
  document.cookie = `${ANALYTICS_COOKIE}=${allowed ? decidedAt : ""}; Domain=seam.co; Path=/; Max-Age=${remaining}; SameSite=Lax; Secure`
}

export const getGoogleMeasurementConsent = () => {
  const advertising = hasAdvertisingConsent()
  return { analytics: advertising || hasGoogleAnalyticsConsent(), advertising }
}
